import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/auth/logout';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { clearCellRouting } from '../../../cellRouting';
import { realtimeDisconnect } from '../../actions/realtime';
import { Error } from '../../actions/error/error';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* operation() {
  try {
    const token = localStorage.getItem('authToken');
    
    if (token) {
      // Call server logout endpoint
      try {
        yield call(axios.post, 
          `${config.API_URL}/user/logout`,
          {},
          { headers: getLocalUser() }
        );
      } catch (error) {
        // Even if server call fails, still clear local data
        console.error('Logout server call failed:', error);
      }
    }
    
    // Always clear client-side data
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    localStorage.removeItem('pendingEmail');
    localStorage.removeItem('USER_ID');
    localStorage.removeItem('WORKSPACE_ID');
    // Drop the per-user cell routing so the next login starts from the baked
    // login/router endpoint again.
    clearCellRouting();

    // Tear down the realtime WebSocket (closes the socket + clears
    // subscriptions). The next login re-opens it.
    yield put(realtimeDisconnect());

    yield put(fetchSuccess());

    // Redirect only after all cleanup is done. Navigating earlier (e.g. from
    // the component that dispatched the logout) unloads the page before this
    // saga runs, leaving the auth token in localStorage.
    window.location.href = '/login.html';
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
